import { Component, OnInit } from '@angular/core';
import { RestResponse, SearchObject } from '../../services/Rest';
import { BaseComponent } from '../base/base.component';
import { OrderInfo, PaymentInfo} from '../../models/models';


import {Currency, Order, Payment} from '../../models/RestModels';
import {User} from '../../models/RestModels';
import { mergeMap } from 'rxjs/operators';
import { Utils } from 'src/app/classes/Utils';
import { forkJoin, Observable, of } from 'rxjs';
import { ExcelUtils } from 'src/app/classes/ExcelUtils';


interface CurrencyPayment extends Payment
{
	e_currency_id:string;
}

interface CPaymentInfo extends PaymentInfo
{
	currencies:string;
	order_id:number|null;
}


@Component({
	selector: 'app-list-payment',
	templateUrl: './list-payment.component.html',
	styleUrls: ['./list-payment.component.css']
})

export class ListPaymentComponent extends BaseComponent implements OnInit
{
	payment_search:SearchObject<CurrencyPayment> = this.getEmptySearch();
	payment_info_list:CPaymentInfo[] = [];
	user_list:User[] = [];
	order_by_payment_id:Record<number,number> = {};
	access_denied:boolean = false;

	fecha_inicial:string = '';
	fecha_final:string = '';
    currencies_list:Currency[] = [];

	ngOnInit()
	{
		this.path = '/list-payment';

		if( !this.rest.current_permission.reports )
		{
			this.access_denied = true;
			this.is_loading = false;
			return;
		}

		this.subs.sink = this.route.queryParamMap.pipe
		(
			mergeMap((param_map)=>
			{
				let fields = [
					"id","created_by_user_id","company_id","type","payment_amount",
					"received_amount", "change_amount", "exchange_rate",
					"received_by_user_id", "paid_by_user_id","created","updated",'e_currency_id',
					"currency_id"

				];

				let extra_keys:Array<string> = []; //['search_param1','project_id','some_id'];
				this.payment_search = this.getSearch(param_map, fields );
				this.setTitle('Lista de Pagos');
				this.current_page = this.payment_search.page;
				this.payment_search.eq.type = 'income';
				if( this.payment_search.sort_order.length == 0 )
				{
					this.payment_search.sort_order = ['id_DESC'];
				}
				this.payment_info_list = [];
				this.is_loading = true;

				this.payment_search.search_extra['ares'] = this.rest.has_ares ? 1 : null;

				if( !this.payment_search.ge.created )
				{
					let d = new Date();
					d.setDate(1);
					d.setHours(0,0,0,0);
					this.payment_search.ge.created = d;
				}

				if( !this.payment_search.le.created )
				{
					let d = new Date();
					let end = Utils.getEndOfMonth( d );
					this.payment_search.le.created = end;
				}

				this.fecha_inicial = Utils.getLocalMysqlStringFromDate( this.payment_search.ge.created ).replace(' ','T');
				this.fecha_final = Utils.getLocalMysqlStringFromDate( this.payment_search.le.created ).replace(' ','T');



				return forkJoin
				({
					currencies: this.currencies_list.length == 0 ? this.rest.currency.search({limit:9999}) : of({data: this.currencies_list, total: this.currencies_list.length}),
					payment: this.rest.payment_info.search(this.payment_search),
					user: this.rest.user.search
					({
						limit:9999, eq:{type:'USER'},
						sort_order:['name_ASC'],
						search_extra:{ 'user_permission.pos': 1 }
					})
				})
			})
		)
		.subscribe((responses)=>
		{
			this.user_list = responses.user.data;

			if( this.currencies_list.length == 0 )
			{
				this.currencies_list = responses.currencies.data;
			}

			responses.payment.data.forEach((payment_info)=>
			{
				let ids = [];

				payment_info.movements.forEach((bmi)=>
				{
					bmi.bank_movement_orders.forEach((bmo)=>
					{
						ids.push( bmo.order_id );
					})
				})

				if( ids.length > 0 )
				{
					this.order_by_payment_id[ payment_info.payment.id ] = ids[0];
				}
			});

			this.setPages( this.payment_search.page, responses.payment.total );

			this.payment_info_list = responses.payment.data.map((pi)=>
			{

				let order_id:number |null = null;

				let c = new Map<string,string>();
				for(let bmi of pi.movements)
				{
					c.set(bmi.bank_movement.currency_id,bmi.bank_movement.currency_id);
					if( !order_id )
					{
						for(let bmo of bmi.bank_movement_orders)
						{
							order_id = bmo.order_id;
							break;
						}
					}
				}

				let ca = Array.from( c.keys() );
				let currencies = ca.join(',');

				return {...pi,order_id, currencies};
			});

			this.is_loading = false;
		},(error)=>this.showError(error));
	}

	imprimir(payment_info:PaymentInfo)
	{
		Utils.openPrintTab('/#/print-receipt/'+this.rest.local_preferences.default_print_receipt+'/'+payment_info.payment.id+'/print');
	}

	sortIcon(header:string)
	{
		if( this.payment_search.sort_order[0] == header+'_ASC' ) return '▲';
		if( this.payment_search.sort_order[0] == header+'_DESC') return '▼';
		return '';
	}

	fechaIncialChange(fecha:string)
	{
		this.fecha_inicial = fecha;
		if( fecha )
		{
			this.payment_search.ge.created = Utils.getDateFromLocalMysqlString(fecha);
		}
		else
		{
			this.payment_search.ge.created = null;
		}
	}

	fechaFinalChange(fecha:string)
	{
		this.fecha_final = fecha;
		if( fecha )
		{
			this.payment_search.le.created = Utils.getDateFromLocalMysqlString(fecha);
		}
		else
		{
			this.payment_search.le.created = null;
		}
	}

	payment_type_legend:Record<string,string> = {
		'CASH':'Efectivo',
		'CREDIT_CARD':'Tarjeta Crédito',
		'DEBIT_CARD':'Tarjeta Débito',
		'CHECK':'Cheque',
		'TRANSFER':'Transferencia',
		'COUPON':'Cupón',
		'DISCOUNT':'Descuento',
		'RETURN_DISCOUNT':'Devolución',
		'PAYPAL':'PayPal',
		'DIGITAL_WALLET':'Monedero',
	};

	//Las paginas se piden una por una (no en paralelo) para no saturar el servidor con rangos grandes
	getAllPayments():Observable<RestResponse<PaymentInfo>>
	{
		let search:SearchObject<Payment> = {...this.payment_search};
		search.limit = 100;
		search.page = 0;

		return this.rest.payment_info.search( search ).pipe
		(
			mergeMap((first)=>
			{
				let pages = Math.ceil( first.total/100 );

				if( pages <= 1 )
					return of( first );

				let searches:SearchObject<Payment>[] = [];

				for(let i=1;i<pages;i++)
				{
					searches.push({...search, page: i });
				}

				return this.rest.payment_info.doSearchAll( searches, false, ()=>{} )
				.pipe
				(
					mergeMap((rest_pages)=>
					{
						first.data.push( ...rest_pages.data );
						return of( first );
					})
				);
			})
		);
	}

	//Las ordenes se piden en bloques de 100, una peticion a la vez
	getOrdersInfo(order_ids:number[]):Observable<RestResponse<OrderInfo>>
	{
		let searches:Partial<SearchObject<Order>>[] = [];

		for(let i=0;i<order_ids.length;i+=100)
		{
			let chunk = order_ids.slice(i,i+100);
			searches.push({ csv:{ id: chunk }, limit: chunk.length });
		}

		return this.rest.order_info.doSearchAll( searches, true, ()=>{} );
	}

	//Un renglon por cada forma de pago y orden abonada
	exportExcel()
	{
		this.is_loading = true;

		this.subs.sink = this.getAllPayments().pipe
		(
			mergeMap((payments)=>
			{
				let order_ids:number[] = [];

				payments.data.forEach((pi)=>
				{
					pi.movements.forEach((bmi)=>
					{
						bmi.bank_movement_orders.forEach((bmo)=>
						{
							if( !order_ids.includes( bmo.order_id ) )
								order_ids.push( bmo.order_id );
						});
					});
				});

				return forkJoin
				({
					payments: of( payments ),
					orders: this.getOrdersInfo( order_ids ),
					price_types: this.rest.getPriceTypes()
				});
			})
		)
		.subscribe((response)=>
		{
			let order_info_by_id:Map<number,OrderInfo> = new Map();
			response.orders.data.forEach((oi)=>order_info_by_id.set( oi.order.id, oi ));

			let price_type_by_id:Map<number,string> = new Map();
			response.price_types.data.forEach((pt)=>price_type_by_id.set( pt.id, pt.name || '' ));

			let rows:any[] = [];

			response.payments.data.forEach((pi)=>
			{
				pi.movements.forEach((bmi)=>
				{
					let bm = bmi.bank_movement;

					let bmos = bmi.bank_movement_orders.length
						? bmi.bank_movement_orders
						: [ null ];

					bmos.forEach((bmo)=>
					{
						let order_info = bmo ? order_info_by_id.get( bmo.order_id ) : null;

						let articulos = order_info
							? order_info.items
								.map((oii)=>(oii.order_item.qty != 1 ? oii.order_item.qty+' x ' : '')+(oii.item?.name || ''))
								.join(', ')
							: '';

						let currency_id = bmo ? bmo.currency_id : bm.currency_id;
						let currency_amount = bmo ? bmo.currency_amount : bm.total;

						rows.push({
							'Tipo de consumo': order_info ? ( price_type_by_id.get( order_info.order.price_type_id ) || '' ) : '',
							'Fecha': Utils.getLocalMysqlStringFromDate( pi.payment.created ),
							'Id': pi.payment.id,
							'Cliente': pi.paid_by_user?.name || order_info?.client?.name || order_info?.order?.client_name || '',
							'Articulos': articulos,
							'Forma de pago': this.payment_type_legend[ bm.transaction_type ] || bm.transaction_type,
							'Cantidad': bmo ? bmo.amount : bm.total*bm.exchange_rate,
							'Cantidad USD': currency_id == 'USD' ? currency_amount : '',
							'Orden': bmo ? bmo.order_id : '',
							'Tag': pi.payment.tag,
							'Recibio': pi.created_by_user?.name || ''
						});
					});
				});
			});

			this.is_loading = false;

			const headers = ['Tipo de consumo','Fecha','Id','Cliente','Articulos','Forma de pago','Cantidad','Cantidad USD','Orden','Tag','Recibio'];
			ExcelUtils.array2xlsx(rows, 'Ingresos.xlsx', headers);
		},(error)=>this.showError(error));
	}
}
